import React from 'react';
// 配置路由规则
import { Router,Route,Switch,Redirect } from 'dva/router';
import App from '../App';
import ChangePassWord from '../components/basic/ChangePassWord';
import NoInweixin from '../components/error/NoInweixin';
import BindPhone from '../components/basic/BindPhone';
import Login from '../Login';
import RemoveBind from '../components/basic/RemoveBind';
import Order from '../components/order/Order';
import MonthTj from '../components/echarts/MonthTj';
import WjsOrder from '../components/order/WjsOrder';
import Supplier from '../components/basic/Supplier';
import Jcxx from '../components/basic/Jcxx';
import OrderingPrrson from '../components/order/OrderingPerson';
import ZdrOrder from '../components/order/ZdrOrder';
import ZdrWjsOrder from '../components/order/ZdrWjsOrder';
import ZdrCusMonthTj from '../components/echarts/ZdrCusMonthTj'

//<Router basename={process.env.PUBLIC_URL}> 

let fn = function ({history,app }) {
    return (
        <Router history={history}>
                <div>
                    <Switch>
                       {/*默认访问App*/}
                        <Route path="/home" component={App} />
                        <Route path="/bindPhone" component={BindPhone} />
                        <Route path="/changePassWord" component={ChangePassWord} / >
                        <Route path="/NoInweixin" component={NoInweixin} / >
                        <Route path="/login" component={Login} / >
                        <Route path="/removeBind" component={RemoveBind} / >
                        <Route path="/order" component={Order} />
                        <Route path="/monthTj" component={MonthTj} />
                        <Route path="/wjsOrder" component={WjsOrder} ></Route>
                        <Route path="/supplier" component={Supplier} ></Route>
                        <Route path="/jcxx" component={Jcxx} ></Route>
                        <Route path="/orderingPrrson" component={OrderingPrrson} ></Route>
                        <Route path="/zdrOrder" component={ZdrOrder} ></Route>
                        <Route path="/zdrWjsOrder" component={ZdrWjsOrder} ></Route>
                        <Route path="/zdrCusMonthTj" component={ZdrCusMonthTj} ></Route>
                        <Redirect to="/home" />
                    </Switch>
                </div>              
        </Router>
    )
}

export default fn;
